import { ResponsiveFunnel } from '@nivo/funnel';

const CustomLabels = ({ parts, width }) => (
    <>
      {parts.map(part => (
        <text
            key={part.id}
            x={width}  // right edge of the chart area
            y={part.y}  // vertical center of segment
            textAnchor="end"  // align text to the right
            dominantBaseline="middle"
            style={{
                fill: '#333',
                fontSize: 12,
                fontWeight: 'bold',
                pointerEvents: 'none',
            }}
        >
            {part.data.label}
        </text>
      ))}
    </>
);

// Component rendering the chart
const ConversionFunnel = ( { data, height = 400 } ) => {
    const hasValidFunnelData =
        data.length > 0 &&
        data.every(item =>
            item &&
            typeof item.id !== 'undefined' &&
            typeof item.value === 'number'
        );

    return (
        <div style={{ position: 'relative', height: `${height}px`, width: '100%' }}>
            {
                hasValidFunnelData ? (
                    <ResponsiveFunnel
                        data={data}
                        layers={['separators', 'parts', 'labels', CustomLabels]}
                        margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                        valueFormat={value => `${value}`}
                        // colors={{ scheme: 'nivo' }}
                        colors={{ datum: 'color' }}
                        borderWidth={5}
                        labelColor={{ from: 'color', modifiers: [['darker', 2]] }}
                        beforeSeparatorLength={50}
                        afterSeparatorLength={50}
                        separatorOffset={20}
                        currentPartSizeExtension={2}
                        currentBorderWidth={5}
                        motionConfig="wobbly"
                    />
                ) : (
                    <div className="h-100 d-flex align-items-center justify-content-center text-muted">
                        No conversion data available
                    </div>
                )
            }
        </div>
    );
}


export default ConversionFunnel;